export default "__VITE_ASSET__BV_nMs1f__"